import * as React from 'react';
import { useSelector } from 'react-redux';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { selectBreadcrumbs } from '../../selectors/breadcrumbs';

export const BreadcrumbsContainer: React.FC = () => {
  const breadcrumbs = useSelector(selectBreadcrumbs);

  if (breadcrumbs.length === 0) {
    return null;
  }

  return <Breadcrumbs breadcrumbs={breadcrumbs} />;
};
